import { render, staticRenderFns } from "./NoTenantsView.vue?vue&type=template&id=2a30a989&scoped=true"
import script from "./NoTenantsView.vue?vue&type=script&lang=js"
export * from "./NoTenantsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a30a989",
  null
  
)

export default component.exports